import { useState } from 'react'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'
import { LOCAL_STORAGE_KEYS } from 'config/Vars'

import i18n from 'modules/core/lib/i18n'
import useLocalStorage from 'modules/core/lib/useLocalStorage'

import HintModal from 'modules/documents/components/BulkFiles/ManualDocumentAssigner/HintModal'
import { UploadProcess } from 'modules/documents/hooks/useGetUploadProcess'

import CancelUploadProcess from './CancelUploadProcess'

interface Props {
  uploadProcess: UploadProcess
}

const AssignerHeader = ({ uploadProcess }: Props) => {
  const [showHintModal, setShowHintModal] = useState(false)
  const [_hasSeenHintModal, setHasSeenHintModal] = useLocalStorage<boolean>(
    LOCAL_STORAGE_KEYS.hideDocumentPayslipsDistributionHint,
    false
  )

  const openInfo = () => {
    setHasSeenHintModal(false)
    setShowHintModal(true)
  }

  const onClose = () => {
    setShowHintModal(false)
  }

  const onFinish = () => {
    setShowHintModal(false)
  }

  return (
    <>
      <Box
        flexDirection="row"
        alignItems="center"
        paddingY="s12"
        paddingX="s16"
        justifyContent="spaceBetween"
        border={{
          bottom: {
            width: 's1',
            style: 'solid',
            color: 'grey400',
          },
        }}
      >
        <Box flexDirection="row" gap="s8">
          <Text size="300" weight="semibold">
            {i18n.t('split_documents.workflow_payslips.header.title')}
          </Text>
        </Box>
        <Box flexDirection="row">
          <Box paddingLeft="s8">
            <Box flexDirection="row" gap="s8">
              <Button
                onClick={openInfo}
                type="secondary"
                disabled={!uploadProcess}
                iconName="info"
              />
              <CancelUploadProcess uploadProcess={uploadProcess} />
            </Box>
          </Box>
        </Box>
      </Box>
      {showHintModal && <HintModal onClose={onClose} onFinish={onFinish} />}
    </>
  )
}

export default AssignerHeader
